import React, { useState, useEffect,useRef} from "react";
import api from "../../services/api";
import NoDataFound from "../../shared/NoDataFound";
import { Toast } from "../../shared/Toast";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { debounce, debouncePromise } from "../../utils/Debounce";
import {EenaduAdsTypes ,EenaduAdSizes,languageOptions, roles} from "../../utils/constants";
import { useForm,useWatch } from "react-hook-form";
import { Controller } from "react-hook-form";
import { useNavigate } from "react-router";
import Select from "react-select";
import {
  SlButton,
  SlDrawer,
  SlInput,
  SlIcon,
  SlBadge,
  SlAlert
} from "@shoelace-style/shoelace/dist/react";
import ReportBirdview from "../SalesPanel/ReportBirdview";
import "../creatives/CreativeList.scss";

const fmtINR = (v) => `₹${(Number(v) || 0).toLocaleString("en-IN")}`;

const EenaduPageRates = () =>{

    const [data,setdata] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages,setTotalPages] = useState(0);
    const [currentPage,setCurrentPage] = useState(0);
    const [loader,setLoader] = useState(false);
    const [search, setSearch] = useState("");
    const [filtertype,setfiltertype] = useState('state');
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [uploader,setuploader] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [locations,setlocations]=useState([]);
    const [pagetypes,setPageTypes] = useState([]);
    const [adtypes,setAdtypes]= useState([])
    const [errorDrawerOpen, setErrorDrawerOpen] = useState(false);
    const [showCustomLocationInput, setShowCustomLocationInput] = useState(false);
    const [isedit,setisedit]=useState(false);
    const [isCombined, setIsCombined] = useState(false);
    const [selectedNewspaper, setSelectedNewspaper] = useState('Eenadu');
    const [newspapers, setNewspapers] = useState([]);
    const [stateOptions, setStateOptions] = useState([])
    const [districtOptions, setDistrictOptions] = useState([])
    const [constituencyOptions, setConstituencyOptions] = useState([])
    const [reportId, setReportId] = useState(0)
    const [showReport, setShowReport] = useState(false)
    const [reportData, setReportData] = useState({})
    const defaultValues = {
      location_type: "",
      location: "",
      page_type: "",
      ad_type: "",
      ad_size: "",
      price: "",
      bw_price: "",
      lang_id:"",
      state_ids:[],
      dist_ids:[],
      constituency_ids:[]
    }
    
    const navigate = useNavigate()
    const [initialRendering, setInitialRendering] = useState(true);


    const PAGE_TYPES_REQUIRING_AD_TYPE = [
      'front_page',
      'page3', 
      'back_page',
      'inner_page',
      'jackect_inside',
      'page2',
      'last_page',
      'display_ad'
    ];
    
    
    useEffect(() => {
      const fetchNewspapers = async () => {
        const res = await api({ url: "/market/newspapers", method: "POST", data: {} });
        if (res?.code === 200) {
          const formatted = res.data
            .filter((item) => item?.name?.toLowerCase() !== "way2news")
            .map((item) => ({
              value: item.name.toLowerCase() === "dinathanthi" ? "dailythanthi" : item.id,
              label: item.name.toLowerCase() === "dinathanthi" ? "Dailythanthi" : item.name,
              logo: item.logo,
            }));
          setNewspapers(formatted);
          const eenadu = formatted.find((p) => p.label.toLowerCase() === "eenadu");          
          console.log("here",eenadu)
          if (eenadu) {
            setSelectedNewspaper(eenadu.value);
          };
        }
      };
      fetchNewspapers();
    }, []);
    
    const handlePageClick = (event) => {
      setCurrentPage(event.selected);
      getData(event.selected,search);
    };
    const searchData = (e) => {
      setSearch(e.target.value);
      setCurrentPage(0);
      getData(0,e.target.value);
    };
    const getData = async(page=0,search='')=>{
      if(!selectedNewspaper)
        return;
      setLoader(true);
      try{
        let res = await api({
          url: `/eenenadupagerates/getpagerates`,
          method: 'POST',
          responseType: 'json',
          data: {
            filtertype,
            page,
            search,
            limit: config.PER_PAGE,
            newspaper:selectedNewspaper
          }
      })
      if(res.code === 200)
      {
         setdata(res.data?.data);
         setTotalRecords(res.data?.total || 0);
         setTotalPages(Math.ceil(res.data?.total / config.PER_PAGE));
      }
      else if(res.code === 500)
        {
          Toast("error", res.data.message);
        }
      setLoader(false)
       }catch(err)
       { 
         setLoader(false)
         console.log(err)
       }
    }
    const getLocations = async()=>{
      try {
          const res = await api({ url: `/eenenadupagerates/getAlllocations`, method: "POST", data: {selectedLocationType,newspaper:selectedNewspaper}});
          if (res.code === 200) setlocations(res.data);
        } catch (error) {}
    }
    const loadPageTypes = async () => {
      try {
        const res = await api({ url: "/eenenadupagerates/getpage_types", method: "POST",data:{allowmultiple:true,newspaper:selectedNewspaper}});
        if (res?.code === 200 && Array.isArray(res?.data)) {
          setPageTypes(res.data);
        }
      } catch (error) {
        console.error("Error loading page types:", error);
        setPageTypes([]);
      }
    };
    const loadAdFormats = async () => {
      try {
        const res = await api({ url: "/eenenadupagerates/getad_types", method: "POST",data:{allowmultiple:true,newspaper:selectedNewspaper}});
        if (res?.code === 200 && Array.isArray(res?.data)) {
          setAdtypes(res.data);
        }
      } catch (error) {
        console.error("Error loading ad formats:", error);
        setAdtypes([]);
      }
    };
    useEffect(()=>{
      if(filtertype && selectedNewspaper)
      {
        setCurrentPage(0);
        getData(0,search);
      }
    },[filtertype,selectedNewspaper])
    useEffect(()=>{
      if(open)
      {  
         loadPageTypes();
         loadAdFormats();
      }
    },[open])
    function handleRequestClose(event) {
      if (event.detail.source === "overlay") {
        event.preventDefault();
      }
    }
    const {
      register,
      control,
      handleSubmit,
      reset,
      watch,
      setValue,
      clearErrors,
      getValues,
      formState: { errors },
    } = useForm({
      mode: "onChange",
      defaultValues,
    });
    const selectedLang_id = watch("lang_id");
    const selectedPageType = watch("page_type");
    const selectedLocationType = watch("location_type");
    const selectedAdType = watch("ad_type");
    const selectedState_ids = watch("state_ids");
    const selectedDist_ids = watch("dist_ids");

    useEffect(()=>{
      if(selectedLocationType)
      {
        getLocations();
      }
    },[selectedLocationType])
    useEffect(()=>{
      if (isedit && initialRendering)
        return;
      if(selectedPageType && selectedNewspaper === 'Eenadu')
      {
        if(['j1','j2','j3','j1+j2'].includes(selectedPageType))
          setValue('ad_type',selectedPageType)
        else
          setValue('ad_type',null)
      }
    },[selectedPageType])

    useEffect(() => {
      if (isedit && initialRendering)
        return;

      if(selectedAdType && selectedNewspaper === 'Eenadu')
      {
        if(!['j1','j2','j3','j1+j2'].includes(selectedAdType)) {
          if(['j1','j2','j3','j1+j2'].includes(selectedPageType)) {
            setValue('page_type',null);
          }
        }
        else
        {
          setValue('page_type',selectedAdType);
        }
      }
    }, [selectedAdType]);

    const requiresAdType = PAGE_TYPES_REQUIRING_AD_TYPE.includes(
      selectedPageType?.toLowerCase?.() || ""
    );
    const handleCloseErrorDrawer = () => {
      setErrorDrawerOpen(false);
      setValidationErrors([]);
    };

    const onSubmit = async(data) => {
        try{
            const payload={
              ...data,
              newspaper:selectedNewspaper
            }
            if(!isedit)
            {
                let res = await api({
                  url: '/eenenadupagerates/addpagerate',
                  method: 'POST',
                  responseType: 'json',
                  data:payload
                })
                if(res.code == 200)
                  {
                    setOpen(false);
                    reset(defaultValues);
                    Toast("success", "PageRate  Successfully!");
                    setCurrentPage(0);
                    getData(0,search);
                  }
                else 
                  {
                      Toast("error", res.data.message);
                  }
            }
            else
            {
              let res = await api({
                url: '/eenenadupagerates/editpagerate',
                method: 'POST',
                responseType: 'json',
                data:payload
              })
              if(res.code == 200)
                {
                  setOpen(false);
                  setisedit(false);
                  reset(defaultValues);
                  Toast("success", "PageRate Edited Successfully!");
                  setCurrentPage(0);
                  getData(0,search);
                }
              else{
                console.log(res);
                Toast("error", res?.data?.message || 'Try Another Combination');
              }
            }
        }catch(err)
        {
          console.log(err);
        }
    }

    useEffect(() => {
      if (open && !isedit) {
        reset(defaultValues);
      }
      else if(!open)
       reset(defaultValues);
    }, [open]);

    const getStatesbyLangId = async()=>{

      let langs = [selectedLang_id]
      // setConstituencyOptions([]);
      // setDistrictOptions([]);
      // setValue('constituency_ids',null);
      // setValue('dist_ids',null);
      // setValue('state_ids',null);

      try{
        let res = await api({
          url: '/location/getStatesByLangId',
          method: 'POST',
          responseType: 'json',
          data: langs
      })
      if(res.status === 'SUCCESS')
      {
        let states = []
        for await (let item of res.data) {
            const temp = { value: item, label: `${item.state_name}` }
            states.push(temp)
        }
        setStateOptions(states)
        
      }

      }catch(err)
      {
        console.log(err);
      }
    }
    const getDistrictsbyStateId = async()=>{
      let langs = [selectedLang_id]
      let states = selectedState_ids
      setConstituencyOptions([]);
      setValue('constituency_ids',[]);
      try{
        let res = await api({
          url: '/location/getDistrictsByStateId',
          method: 'POST',
          responseType: 'json',
          data: { states, langs }
       })
       if(res.status === 'SUCCESS')
       {
         let districts = []
         for await (let item of res.data) {
             const temp = { value: item, label: `${item.dist_name}` }
             districts.push(temp)
         }
         setDistrictOptions(districts)
       }
      }catch(err)
      {
         console.log(err);
      }
    }
    const getConstituenciesbyDistrictId = async()=>{
      let langs = [selectedLang_id]
      let districts = selectedDist_ids
      try{
        let consties = await api({
          url: `/location/getConstituentsnew`,
          method: 'POST',
          responseType: 'json',
          data: {districts, langs}
        })
        if(consties.status === 'SUCCESS')
        {
          let constituents =[]
          for await(let item of consties.data){
              const temp = { value: item, label: `${item.const_name}`}
              constituents.push(temp)
          }
          setConstituencyOptions(constituents)
        }

      }catch(err)
      {
         console.log(err);
      }
    }
    
    const lang_idsOnchange = async (selected) => {
        const langs = Array.isArray(selected)
                ? (selected[0]?.value ? [selected[0].value] : [])
                : (selected?.value ? [selected.value] : []);

        try {
            let res = await api({
                url: '/location/getStatesByLangId',
                method: 'POST',
                responseType: 'json',
                data: langs
            })
            let states = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.state_name}` }
                states.push(temp)
            }
            setStateOptions(states)
            setValue("state_ids", getValues("state_ids").filter((option) => langs.indexOf(option.lang_id) >= 0))
            setValue("dist_ids", getValues("dist_ids").filter((option) => langs.indexOf(option.lang_id) >= 0))
            setValue("constituency_ids", getValues("constituency_ids").filter((option) => langs.indexOf(option.lang_id) >= 0))
        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const state_idsOnchange = async (selected, langs) => {
        const states = selected ? (selected).map((item) => { if (item.value) return item.value.state_id }) : []
        langs = Array.isArray(langs) ? langs : (langs ? [langs] : []);

        try {
            let res = await api({
                url: '/location/getDistrictsByStateId',
                method: 'POST',
                responseType: 'json',
                data: { states, langs }
            })
            let districts = []
            for await (let item of res.data) {
                const temp = { value: item, label: `${item.dist_name}` }
                districts.push(temp)
            }
            setDistrictOptions(districts)
            let temp = []
            setValue("dist_ids", getValues("dist_ids").filter((option) => { if (states.indexOf(option.state_id) >= 0) { temp.push(option.dist_id); return true } }))
            setValue("constituency_ids", getValues("constituency_ids").filter((option) => temp.indexOf(parseInt(option.dist_id)) >= 0))
        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const district_idsOnchange = async (selected, langs) => {
        const districts = selected ? (selected).map((item) => { if (item.value) return item.value.dist_id }) : []
        langs = Array.isArray(langs) ? langs : (langs ? [langs] : []);
        try {

            let consties = await api({
                url: `/location/getConstituentsnew`,
                method: 'POST',
                responseType: 'json',
                data: {districts, langs}
            })
            let constituents =[]
            for await(let item of consties.data){
                const temp = { value: item, label: `${item.const_name}`}
                constituents.push(temp)
            }
            setConstituencyOptions(constituents)
            setValue("constituency_ids", getValues("constituency_ids").filter((option) => districts.indexOf(parseInt(option.dist_id)) >= 0))

        } catch (error) {
            console.error(error);
            if (error.response.status === 401)
                navigate("/")
        }

    }
    const getPageRatesTarget = async(id)=>{
      try{
        let res = await api({
          url: '/user/target/getPageRatesTarget',
          method: 'POST',
          responseType: 'json',
          data: { id }
      })
      if(res.status === 'SUCCESS')
      {
        return res.data;
      }
      else
      return {}
      }catch(err)
      {
        console.log(err);
      }
    }
    const onchange = (selected, field) => {
      setValue(field, selected ? (selected).map((item) => item.value) : []);
    }
    const langonchange = (selected, field) => {
      setValue(field, selected ? selected[0]?.value : "");
    }
    const setfield = async (array, field, temp, lang_ids) => {
      let arr = []
      if (Array.isArray(array) && field !== "state_ids" && field !== "dist_ids" && field !== "constituency_ids")
          array?.map((x) => arr.push({ value: x, label: x }))

      switch (field) {

          case "lang_id":
              await lang_idsOnchange(arr)
              await langonchange(arr, "lang_id");
              break
          case "state_ids":
              let states = []
              for await (let item of array) {
                  const temp = { value: item, label: `${item.state_name}` }
                  states.push(temp)
              }
              await state_idsOnchange(states, lang_ids)
              onchange(states, "state_ids")
              break
          case "dist_ids":
              let districts = []
              for await (let item of array) {
                  const temp = { value: item, label: `${item.dist_name}` }
                  districts.push(temp)
              }
              await district_idsOnchange(districts, lang_ids)
              onchange(districts, "dist_ids")
              break
          case 'constituency_ids':
              let constituents = []
              for await (let item of array) {
                  const temp = {value: item, label: `${item.const_name}`}
                  constituents.push(temp)
              }
              onchange(constituents, 'constituency_ids')
          default:

      }
  }

    const handleEdit = async (item) => {
  
      const targetobj = await getPageRatesTarget(item.id);
      setisedit(true);
      setSelectedItem(item);
      setOpen(true);
      if(targetobj?.lang_id)
      {
        await setfield([targetobj.lang_id], "lang_id", [])
        await setfield(targetobj.state_ids, "state_ids", [], [targetobj.lang_id])
        await setfield(targetobj.district_ids, "dist_ids", [], [targetobj.lang_id])
        await setfield(targetobj.constituency_ids, "constituency_ids", [], [targetobj.lang_id])   
      }

      if(item.location?.includes('+'))
      {
        setIsCombined(true);
      }
      setValue('id',item.id);
      setValue('location_type', item.location_type || "");
      setValue('ad_size', item.ad_size || "");
      setValue('location', item.location ? item.location.split('+').map(s => s.trim()) : []);
      setValue('page_type', item.page_type || "");
      setValue('ad_type', item.ad_type || "");
      setValue('price', item.price || 0);
      setValue('bw_price', item.bw_price || 0);
      
    };
    const handleAddNew = () => {
      setOpen(true);
      reset(defaultValues)
    };
    
    const handleFileUpload = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
    
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel',                                           // .xls
        'application/vnd.oasis.opendocument.spreadsheet'                      // .ods
      ];
      if (!validTypes.includes(file.type)) {
        Toast('error', 'Please upload a valid Excel file (.xlsx or .xls or .ods)');
        return;
      }
    
      try {
        const XLSX = await import('xlsx');
        
        const reader = new FileReader();
        
        reader.onload = async (event) => {
          try {
            // Read Excel file
            const workbook = XLSX.read(event.target.result, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(sheet, {
              raw: false,
              defval: '',
              blankrows: false
            }); 
            
            // Basic validation
            if (!data || data.length === 0) {
              Toast('error', 'Excel file is empty');
              return;
            }
            
            
            // Send directly to backend
            await handleBulkUpload(data);
            
          } catch (err) {
            console.error('Error parsing Excel:', err);
            Toast('error', 'Failed to read Excel file');
          }
        };
        
        reader.onerror = () => {
          Toast('error', 'Error reading file');
        };
        
        reader.readAsBinaryString(file);
        
        // Clear input
        e.target.value = '';
        
      } catch (error) {
        console.error('Upload error:', error);
        Toast('error', 'Failed to process Excel file');
      }
    };
    const handleBulkUpload = async (excelData) => {
      try {
        Toast('info', `Processing ${excelData.length} rows...`);
        setuploader(true);
        
        const response = await api({
          url: '/eenenadupagerates/bulkUploadPageRates',
          method: 'POST',
          responseType: 'json',
          data: {
            data: excelData,
            newspaper:selectedNewspaper 
          }
        });
        if (response.code === 200) {
          Toast('success', `${response.data?.inserted || 0} inserted`);
          Toast('success', `${response.data?.updated || 0} updated`);
          getData(currentPage, search); 
        } else if (response.data.code === 400) {
          // Handle validation errors
          if (response.data?.message) {
            const errors = response.data?.message.split(',').map(err => err.trim());
            setValidationErrors(errors);
            setErrorDrawerOpen(true);
          }
        }
        
        setuploader(false);
      } catch (error) {
        console.error('Bulk upload error:', error);
        setuploader(false);
        
        if (error.response?.status === 400 && error.response?.data?.message) {
          const errorMessage = error.response.data.message;
          
          const errors = errorMessage.split(',').map(err => err.trim());
          
          setValidationErrors(errors);
          setErrorDrawerOpen(true);
        } else {
          const errorMessage = error.response?.data?.message || 
                              error.response?.data?.error || 
                              error.message || 
                              'Failed to upload data';
          Toast('error', errorMessage);
        }
      }
    };
    const handleCombinedChange = (e) => {
      const checked = e.target.checked;
      setIsCombined(checked);
      setValue('locations', checked ? [] : null);
  };
    return(
     <>
      <div className="creativeListPage flex flex-col h-[calc(100vh-72px)]">
       <div className="cl-card flex min-h-0 flex-1 flex-col">
        <header className="cl-header shrink-0">
        <div className="cl-title-block">
          <h1 className="cl-title">Page Rates</h1>
          <p className="cl-subtitle">
            {newspapers.find((o) => o.value === selectedNewspaper)?.label ||
              (typeof selectedNewspaper === "string" ? selectedNewspaper : "")}{" "}
            · {data?.length || 0} rates
          </p>
        </div>
        <div className="cl-toolbar cl-toolbar--inline">
        <Select value={newspapers.find(opt => opt.value === selectedNewspaper)} onChange={opt => setSelectedNewspaper(opt ? opt.value : null)} options={newspapers} placeholder="Newspaper" className="text-sm w-48" isDisabled={!newspapers.length} />
        <Select
          options={EenaduAdsTypes}
          placeholder="Filter by Location Type"
          className="w-[200px] text-sm"
          classNamePrefix="react-select"
          value={EenaduAdsTypes.find(opt => opt.value === filtertype) || null}
          onChange={opt => setfiltertype(opt ? opt.value : null)}
        />
        <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name">
          <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
        <div className="relative">
          <input
            type="file"
            id="excelUpload"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            className="hidden"
          />

          {uploader ? (
            // show loader
            <div className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white bg-gray-500 rounded cursor-not-allowed">
              <svg
                className="animate-spin h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                ></path>
              </svg>
              Uploading...
            </div>
          ) : (
            // show upload button
            <label
              htmlFor="excelUpload"
              className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded cursor-pointer"
            >
              <SlIcon library="lucide" name="upload" />
              Upload File
            </label>
          )}
        </div>
        <SlButton
          size="small"
          variant="primary"
          onClick={() => {
            handleAddNew()
          }}
        >
          Add Page Rate
        </SlButton>
        </div>
        </header>
        <div className="cl-table-wrap flex-1 min-h-0 overflow-y-auto">
          <table className="cl-table cl-table--multi">
            <thead>
              <tr>
                <th>Location</th>
                <th>Newspaper</th>
                <th>Location Type</th>
                <th>Page Type</th>
                <th>Ad Type</th>
                <th>Ad Size</th>
                <th>Color Price</th>
                <th>B&W Price</th>
                <th>Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td className="cl-name" data-label="Location">{item?.location?.toUpperCase()}</td>
                    <td data-label="Newspaper">{item?.newspaper_name?.toUpperCase()}</td>
                    <td data-label="Location Type">{item?.location_type?.toUpperCase()}</td>
                    <td data-label="Page Type">
                      <span className="inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">{item?.page_type?.toUpperCase()}</span>
                    </td>
                    <td data-label="Ad Type">
                      {item?.ad_type ? (
                        <span className="inline-flex items-center rounded-md bg-[#eff6ff] px-2 py-0.5 text-xs font-semibold text-[#2563eb]">{item.ad_type.toUpperCase()}</span>
                      ) : (
                        <span className="text-slate-400">-</span>
                      )}
                    </td>
                    <td data-label="Ad Size">{item?.ad_size?.toUpperCase()}</td>
                    <td data-label="Color Price" className="font-semibold text-slate-800">{fmtINR(item?.price)}</td>
                    <td data-label="B&W Price" className={Number(item?.bw_price) ? "font-semibold text-slate-800" : "text-slate-400"}>{fmtINR(item?.bw_price)}</td>
                    <td data-label="Actions">
                      <div className="cl-actions">
                        {localStorage.getItem("role") !== roles.salesperson && (
                          <sl-tooltip content="Edit PageRate">
                            <sl-icon-button library="lucide" name="edit" onClick={() => handleEdit(item)}></sl-icon-button>
                          </sl-tooltip>
                        )}
                        {localStorage.getItem("role") === roles.salesperson && (
                          <button
                            onClick={() => {
                              setReportId(item.id);
                              setShowReport(true);
                              setReportData(item);
                            }}
                            className="inline-flex items-center gap-1 rounded-md border border-red-500 bg-white px-2 py-1 text-xs font-bold text-red-500 hover:bg-red-500 hover:text-white"
                          >
                            <sl-icon library="lucide" name="alert-triangle"></sl-icon>
                            <span>Report</span>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="9" />
            ) : (
              <TableLoader colspan="9" />
            )}
          </table>
        </div>
        {totalPages > 1 && (
          <div className="cl-pagination shrink-0 !justify-between">
            <span className="self-center text-sm text-slate-500">Showing {data?.length || 0} of {totalRecords} rates</span>
            <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />
          </div>
        )}
       </div>
      </div>
      <SlDrawer
        label={`${selectedNewspaper?.toUpperCase()} PAGE RATE`}
        open={open}
        onSlAfterHide={() => {setOpen(false);reset(defaultValues);setSelectedItem(null);setShowCustomLocationInput(false);setIsCombined(false);setisedit(false)}}
        placement="end"
      >
        <form className="grid gap-4 p-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Location Type */}
          <div>
              <label className="block text-sm font-medium mb-1">
                Location Type <span className="text-red-500">*</span>
              </label>
              <Controller
                name="location_type"
                control={control}
                rules={{ required: "location_type is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={EenaduAdsTypes}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={
                      EenaduAdsTypes.find(opt => opt.value === field.value) || null
                    }
                    onChange={opt => field.onChange(opt ? opt.value : "")}
                  />
                )}
                isDisabled={isedit}
              />
              {errors.location_type && (
                <p className="text-red-500 text-xs mt-1">{errors.location_type.message}</p>
              )}
          </div>

          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              id="combined"
              checked={isCombined}
              onChange={handleCombinedChange}
              className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              disabled={isedit}
            />
            <label htmlFor="combined" className="text-sm font-medium text-gray-700">
              Combined
            </label>
          </div>

          {selectedLocationType && (
            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="block text-sm font-medium">
                  Location <span className="text-red-500">*</span>
                </label>
                {!isCombined && !isedit && (
                  <button
                    type="button"
                    className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 transition-colors"
                    onClick={() => {
                      setShowCustomLocationInput(!showCustomLocationInput);
                      setValue('location', [], { shouldValidate: true }); // Changed to empty array
                      clearErrors('location');
                    }}
                  >
                    {showCustomLocationInput ? "← Select from list" : "+ Add Custom Location"}
                  </button>
                )}
              </div>

              {!showCustomLocationInput ? (
                <Controller
                  name="location"
                  control={control}
                  rules={{
                    required: "Location is required",
                    validate: value => {
                      if (!value || !Array.isArray(value) || value.length === 0) {
                        return "Location is required";
                      }
                      return true;
                    }
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={locations}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select location"
                      isMulti={isCombined}
                      value={
                        isCombined
                          ? locations.filter(opt => field.value?.includes(opt.value))
                          : locations.find(opt => field.value?.[0] === opt.value) || null
                      }
                      onChange={opt => {
                        if (isCombined) {
                          field.onChange(opt ? opt.map(o => o.value) : []);
                        } else {
                          // Store as single-item array when not combined
                          field.onChange(opt ? [opt.value] : []);
                        }
                      }}
                      isDisabled={isedit}
                    />
                  )}
                />
              ) : (
                <Controller
                  name="location"
                  control={control}
                  rules={{
                    required: "Location is required",
                    validate: value => {
                      if (!value || !Array.isArray(value) || value.length === 0 || !value[0]) {
                        return "Location is required";
                      }
                      if (value[0].includes('+') || value[0].includes(',')) {
                        return "Special characters like '+' and ',' are not allowed";
                      }
                      return true;
                    }
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className="form-control"
                      placeholder="Enter custom location"
                      value={field.value?.[0] || ''}
                      onChange={(e) => {
                        // Store as single-item array
                        field.onChange(e.target.value ? [e.target.value] : []);
                      }}
                      readOnly={isedit}
                    />
                  )}
                />
              )}
              {errors.location && (
                <p className="text-red-500 text-xs mt-1">{errors.location.message}</p>
              )}
            </div>
          )}
            <div className="bg-gray-100 p-4 rounded-lg border border-gray-300">
              <h3 className="text-lg font-semibold mb-4 text-gray-700">
                Enter Corresponding Way2News Serving Locations
              </h3>
              
              <div className="space-y-4">
                {/* Language - Single Select */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Language <span className="text-red-500">*</span>
                  </label>
                  <Controller
                    name="lang_id"
                    control={control}
                    rules={{ required: "Language is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={languageOptions}
                        className="basic-single-select"
                        classNamePrefix="select language"
                        value={languageOptions.find(opt => opt.value === field.value) || null}
                        onChange={opt => {field.onChange(opt ? opt.value : "") ;lang_idsOnchange(opt)}}
                      />
                    )}
                  />
                  {errors.lang_id && (
                    <p className="text-red-500 text-xs mt-1">{errors.lang_id.message}</p>
                  )}
                </div>

                {/* State - Multi Select */}
                <div>
                  <label className="block text-sm font-medium mb-1">
                    State <span className="text-red-500">*</span>
                  </label>
                  <Controller
                    name="state_ids"
                    control={control}
                    rules={{ required: "State is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={stateOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti
                        value={stateOptions.filter(option => field.value.map(i => i.state_id)?.includes(option.value.state_id)) || []}
                        onChange={opt => {
                          field.onChange(opt ? opt.map(o => o.value) : []);
                          state_idsOnchange(opt,getValues("lang_id"));
                        }}
                      />
                    )}
                  />
                  {errors.state_ids && (
                    <p className="text-red-500 text-xs mt-1">{errors.state_ids.message}</p>
                  )}
                </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">
                      District
                    </label>
                    <Controller
                      name="dist_ids"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={districtOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti
                          value={districtOptions.filter(option => 
                            field.value?.map(i => i.dist_id)?.includes(option.value?.dist_id)
                          ) || []}
                          onChange={opt => {
                            field.onChange(opt ? opt.map(o => o.value) : []);
                            district_idsOnchange(opt, getValues('lang_id'));
                          }}
                        />
                      )}
                    />
                    {errors.dist_ids && (
                      <p className="text-red-500 text-xs mt-1">{errors.dist_ids.message}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Constituency
                    </label>
                    <Controller
                      name="constituency_ids"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={constituencyOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isMulti
                          value={constituencyOptions.filter(option => 
                            field.value?.map(i => i.const_id)?.includes(option.value?.const_id)
                          ) || []}
                          onChange={opt => field.onChange(opt ? opt.map(o => o.value) : [])}
                        />
                      )}
                    />
                    {errors.constituency_ids && (
                      <p className="text-red-500 text-xs mt-1">{errors.constituency_ids.message}</p>
                    )}
                  </div>
              </div>
            </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Page Type <span className="text-red-500">*</span>
            </label>
            <Controller
              name="page_type"
              control={control}
              rules={{ required: "Page Type is required" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={pagetypes}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select page type"
                  value={pagetypes.find(opt => opt.value === field.value) || null}
                  onChange={opt => field.onChange(opt ? opt.value : "")}
                  isDisabled={isedit}
                />
              )}
            />
            {errors.page_type && (
              <p className="text-red-500 text-xs mt-1">{errors.page_type.message}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Ad Type {requiresAdType && <span className="text-red-500">*</span>}
            </label>
            <Controller
              name="ad_type"
              control={control}
              rules={{
                required: requiresAdType ? "Ad Type is required for this Page Type" : false,
              }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={adtypes}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select ad type"
                  value={adtypes.find(opt => opt.value === field.value) || null}
                  onChange={opt => field.onChange(opt ? opt.value : "")}
                  isDisabled={isedit} 
                />
              )}
            />
            {errors.ad_type && (
              <p className="text-red-500 text-xs mt-1">{errors.ad_type.message}</p>
            )}
          </div>
          {/* Ad Size */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Ad Size <span className="text-red-500">*</span>
            </label>
            <Controller
                name="ad_size"
                control={control}
                rules={{ required: "ad_size is required" }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={EenaduAdSizes}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={
                      EenaduAdSizes.find(opt => opt.value === field.value) || null
                    }
                    onChange={opt => field.onChange(opt ? opt.value : "")}
                    isDisabled={isedit}
                  />
                )}
              />
            {errors.ad_size && (
              <p className="text-red-500 text-xs mt-1">{errors.ad_size.message}</p>
            )}
          </div>

          {/* Color Price */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Color Price <span className="text-red-500">*</span>
            </label>
            <SlInput
              type="number"
              {...register("price", {
                required: "Color price is required",
                min: { value: 0, message: "Price must be positive" },
              })}
            />
            {errors.price && (
              <p className="text-red-500 text-xs mt-1">{errors.price.message}</p>
            )}
          </div>

          {/* B&W Price */}
          <div>
            <label className="block text-sm font-medium mb-1">
              B&W Price <span className="text-red-500">*</span>
            </label>
            <SlInput
              type="number"
              {...register("bw_price", {
                required: "B&W price is required",
                min: { value: 0, message: "Price must be positive" },
              })}
            />
            {errors.bw_price && (
              <p className="text-red-500 text-xs mt-1">{errors.bw_price.message}</p>
            )}
          </div>

          {/* Footer buttons */}
          <div slot="footer" className="flex justify-end gap-2 mt-4">
            <SlButton variant="primary" type="submit">
              Save
            </SlButton>
          </div>
        </form>
      </SlDrawer>
      <SlDrawer
          label={
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <SlIcon name="exclamation-triangle" style={{ color: '#dc3545', fontSize: '20px' }} />
              <span>Validation Errors</span>
              <SlBadge variant="danger" pill>
                {validationErrors.length}
              </SlBadge>
            </div>
          }
          open={errorDrawerOpen}
          onSlAfterHide={handleCloseErrorDrawer}
          placement="end"
          style={{ '--width': '450px' }}
      >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '16px 0' }}>
        <SlAlert variant="warning" open>
          <SlIcon slot="icon" name="info-circle" />
          <strong>Found {validationErrors.length} validation {validationErrors.length === 1 ? 'error' : 'errors'}</strong>
          <br />
          Please fix these errors in your spreadsheet and try uploading again.
        </SlAlert>

        {/* Error List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {validationErrors && validationErrors.map((error, index) => (
            <div
              key={index}
              style={{
                padding: '16px',
                backgroundColor: '#fff5f5',
                border: '1px solid #feb2b2',
                borderLeft: '4px solid #dc3545',
                borderRadius: '4px',
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  minWidth: '28px',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  borderRadius: '50%',
                  fontSize: '12px',
                  fontWeight: '600',
                }}
              >
                {index + 1}
              </div>
              <div style={{ flex: 1, fontSize: '14px', lineHeight: '1.6', color: '#2d3748' }}>
                {error}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div slot="footer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <SlButton variant="primary" onClick={handleCloseErrorDrawer}>
          Close
        </SlButton>
      </div>
    </SlDrawer>
    {showReport && <ReportBirdview reportId={reportId} source={'PageRates'} open={showReport} setOpen={setShowReport} reportData={reportData}/>}
    </>
    )
}
export default EenaduPageRates;